export default class SmartVaultService {
  /* @ngInject */
  constructor(
    $rootScope,
    $http,
    SweetAlertService,
    SecurityManager,
    SmartVault
  ) {
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.SweetAlertService = SweetAlertService;
    this.SecurityManager = SecurityManager;
    this.SmartVault = SmartVault;
  }

  async integrate(email) {
    try {
      return this.SmartVault.integrate(email);
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async integrated() {
    try {
      return this.SmartVault.integrated();
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async getAccounts() {
    try {
      return this.SmartVault.getAccounts();
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async getAccountClients(inputValue) {
    try {
      return this.SmartVault.getAccountClients(inputValue);
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async getClientContacts(clientId) {
    try {
      return this.SmartVault.getClientContacts(clientId);
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async getClient(clientId) {
    try {
      return this.SmartVault.getClient(clientId);
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async createProposal(accountId, clientId) {
    try {
      return this.SmartVault.createProposal(accountId, clientId);
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }

  async syncOrganizations() {
    try {
      return this.SmartVault.syncOrganizations();
    } catch (e) {
      await this.SweetAlertService.integrationError();
    }
  }
}
